import { type PropsWithChildren, useCallback } from 'react';
import { PrivyProvider } from '@privy-io/react-auth';
import { PRIVY_APP_ID_KEY } from "@/utils";
import getAsyncToken from "@/utils/getAsyncToken";
import { useAppSelector } from "@/redux/hooks";
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';

const solanaConnectors = toSolanaWalletConnectors();

const EmbeddedWalletProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const user = useAppSelector((state) => state.user);
  const getCustomToken = useCallback(
    () => getAsyncToken(),
    [user],
  );

  return (
    <PrivyProvider
      appId={PRIVY_APP_ID_KEY}
      config={{
        appearance: {
          theme: "#171717",
          accentColor: "#0080B2",
          walletChainType: 'solana-only',
          walletList: ["phantom"],
        },
        customAuth: {
          isLoading: false,
          getCustomAccessToken: getCustomToken,
        },
        embeddedWallets: {
          createOnLogin: "off",
        },
        externalWallets: {
          solana: {
            connectors: solanaConnectors,
          },
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
};

export default EmbeddedWalletProvider;